import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import { modalPaperStyle } from '../components/RedesignModal/RedesignModal.styles';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

const FEEDBACK_MODAL_MAX_WIDTH = 536;

export const useFeedbackModalStyles = makeStyles(() => ({
  modal: {
    ...modalPaperStyle,
    position: 'relative',
    maxWidth: FEEDBACK_MODAL_MAX_WIDTH,
    alignItems: 'center',
    gap: 22,
    padding: spacing.lg,
    borderRadius: radius.sm,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: spacing.sm,
      gap: spacing.sm,
    },
  },
  closeButton: {
    position: 'absolute',
    top: spacing.sm,
    right: spacing.sm,
    padding: 0,
    color: colors.overlay,
    '&:hover': {
      backgroundColor: 'transparent',
      opacity: 0.7,
    },
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      top: spacing.xs,
      right: spacing.xs,
    },
  },
  closeIcon: {
    width: 24,
    height: 24,
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing.sm,
    width: '100%',
    paddingTop: spacing.sm,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      paddingTop: spacing.lg,
    },
  },
  title: {
    margin: 0,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.overlay,
    textAlign: 'center',
    lineHeight: 'normal',
  },
  stars: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
  },
  starButton: {
    width: 40,
    height: 40,
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.1)',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  starIcon: {
    width: 40,
    height: 40,
    display: 'block',
  },
  commentSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    width: '100%',
  },
  commentLabel: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: colors.overlay,
    lineHeight: 1.4,
  },
  textarea: {
    width: '100%',
    height: 160,
    padding: '8px 12px',
    boxSizing: 'border-box',
    border: `1px solid ${colors.chatBorder}`,
    borderRadius: 4,
    backgroundColor: colors.white,
    resize: 'none',
    fontFamily: fonts.gothic,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    color: colors.overlay,
    outline: 'none',
    '&::placeholder': {
      color: colors.label,
      opacity: 1,
    },
    '&:focus': {
      borderColor: colors.chatBorder,
    },
  },
  error: {
    margin: 0,
    width: '100%',
    fontFamily: fonts.gothic,
    fontSize: fontSize.md,
    color: colors.error,
    textAlign: 'center',
    lineHeight: 'normal',
  },
  submitButton: {
    width: '100%',
    minHeight: 48,
    borderRadius: 4,
    backgroundColor: colors.primary,
    color: colors.white,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: colors.primary,
      opacity: 0.9,
    },
    '&:disabled': {
      backgroundColor: colors.chatBorder,
      color: colors.label,
    },
  },
}));
